import React, { Component } from 'react'

export default class Venture extends Component {
  render () {

    const { item } = this.props;

    var style = {
      backgroundImage: 'url(' + item.cover_image + ')'
    }
    
    return (
    	<div style={style} className="img img-barrio">
        <div className="overlay-ventures">
        </div>
        <h2>{item.name}</h2>
        <h3>{item.bajada}</h3>	 	
    	</div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/features/PageEntrepreneurship/components/List/venture.js